import React, { useEffect, useRef } from "react"
import Link from "gatsby-plugin-transition-link"
import Img from "gatsby-image"
import classnames from "classnames/bind"
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"
import Splitting from "splitting"

// Component
import { ArrowDown } from "phosphor-react"
import { WideContainer } from "../../layouts/container"
import IconsCircular from "../../assets/icons/circular"

// Style
import heroStyle from "../../style/section/projectpage/hero.module.scss"

const ProjectsHero = props => {
  // fadeInRef Array
  const fadeInRef = useRef([])
  fadeInRef.current = []
  const circularRef = useRef(null)
  const heroImageRef = useRef(null)
  const heroImageSelfRef = useRef(null)

  // - Animate
  useEffect(() => {
    if (typeof window === "undefined" || !window.document) {
      console.log(`windows error`)
    }
    // fadeIn Animation
    gsap
      .timeline()
      .set(fadeInRef.current, {
        autoAlpha: 0,
        y: 80,
      })
      .set(circularRef.current, {
        autoAlpha: 0,
        scale: 0,
      })
      .add("startTime")
      .to(
        fadeInRef.current,
        {
          autoAlpha: 1,
          y: 0,
          stagger: {
            // wrap advanced options in an object
            amount: 0.5,
            ease: "power2.out",
          },
          delay: 1.5,
        },
        "startTime"
      )
      .to(
        circularRef.current,
        {
          autoAlpha: 1,
          scale: 1,
          delay: 1.8,
          duration: 0.2,
        },
        "startTime"
      )

    const heroImageSelf = heroImageSelfRef.current.children
    // parallax effects
    gsap.timeline().to(heroImageSelf, {
      ease: "none",
      scrollTrigger: {
        id: "parallaxHeroImage",
        trigger: heroImageSelf,
        start: "top top",
        end: "bottom top",
        scrub: true,
        markers: false,
      },
      yPercent: 30,
    })
  }, [])

  // Add children to Ref Array
  const addToRefs = el => {
    if (el && !fadeInRef.current.includes(el)) {
      fadeInRef.current.push(el)
    }
  }

  return pug`
    section(className=heroStyle.hero_wrapper)
      WideContainer
        div.flex.flex-col(className=heroStyle.hero_title)
          div.col-4.overflow-hidden.mb-6.px-0
            div.flex.flex-row(ref=addToRefs)
              span.text-2x.text-gray-200=props.num
              div(className=heroStyle.hero_title_deco)
          div.col-12.col-md-10.overflow-hidden.mb-6.pb-2.px-0(className=classnames('md:mb-10'))
            -  const isArray = Array.isArray(props.name)
            if (isArray)
              each item in props.name
                h1.text-3x(className=classnames('sm:text-5x','md:text-6x','md:text-left') ref=addToRefs)=item.text
            else
              h1.text-3x(className=classnames('sm:text-5x','md:text-6x','md:text-left') ref=addToRefs)=props.name
          div.col-12.col-md-8.overflow-hidden.px-0
            span.text-default.text-gray-200(className=classnames('md:text-left') ref=addToRefs)=props.description
          div.justify-center.items-center(className=heroStyle.hero_title_circular ref=circularRef)
            div.flex.justify-center.items-center(className=heroStyle.hero_title_circular_center)
              div(className=heroStyle.hero_title_circular_center_icon)
                ArrowDown(size=48 weight="bold")
              // div(className=heroStyle.hero_title_circular_center_background)
            div(className=heroStyle.hero_title_circular_spinner)
              IconsCircular
            div(className=heroStyle.hero_title_circular_background)

      div#heroImage(className=heroStyle.hero_image ref=heroImageRef)
        figure(className=heroStyle.hero_image_wrapper ref=heroImageSelfRef)
          Img(fluid=props.image_url style={ height:'100%',width:'100%'})
  `
}

export default ProjectsHero
